// removed by extract-text-webpack-plugin
module.exports = {"backgroundCarousel":"BackgroundCarousel__backgroundCarousel","background":"BackgroundCarousel__background","background-enter":"BackgroundCarousel__background-enter","background-enter-active":"BackgroundCarousel__background-enter-active","background-leave":"BackgroundCarousel__background-leave","background-leave-active":"BackgroundCarousel__background-leave-active","growDotQello":"BackgroundCarousel__growDotQello","growDotBlue":"BackgroundCarousel__growDotBlue","growDotGolden":"BackgroundCarousel__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BackgroundCarousel/BackgroundCarousel.scss
// module id = 1841
// module chunks = 0